import React, {ReactNode} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {ShowMoreButton} from "../../../atoms/ShowMoreButton";
import {OfferDisplayType} from "../../../offer/helpers/OfferDisplayType";
import {OfferType} from "../../../offer/types/OfferType";
import {useAppSelector} from "../../../store/hooks";
import {useGetVendorDetailOffersQuery} from "../../api/get_vendor_detail_offers";
import {convertToVendorDetailViewOffersPayload} from "../../utils/convert_to_vendor_detail_view_offers_payload";
import {VendorDetailCommercialsListItem, VendorDetailCommercialsListItemProps} from "./boxes/VendorDetailCommercialsListBox";

interface IListProps {
    offers: VendorDetailCommercialsListItemProps["offer"][];
    vendorSlug: VendorDetailCommercialsListItemProps["vendorSlug"];
}

interface IProps {
    vendorId: number;
    vendorSlug: string;
}

const VendorDetailCommercialsList: React.FC<IListProps> = ({offers, vendorSlug}) => (
    <ul className={commercialsOffersListStyle}>
        {offers.map((offer) => (
            <li key={offer.id} className={listItemStyle}>
                <VendorDetailCommercialsListItem offer={offer} vendorSlug={vendorSlug} />
            </li>
        ))}
    </ul>
);

export const VendorDetailCommercials = (props: IProps & {children: (sectionContent: ReactNode) => ReactNode}) => {
    const {vendorId, vendorSlug} = props;
    const region = useAppSelector((state) => state.vendorDetailViewSlice.activeOffersListParams.region);

    const {data} = useGetVendorDetailOffersQuery(
        convertToVendorDetailViewOffersPayload({
            vendorId,
            region,
            displayType: OfferDisplayType.FOR_SALE,
            type: [OfferType.COMMERCIAL]
        })
    );
    const offers = data?.results ?? [];

    if (offers.length === 0) {
        return null;
    }

    return props.children(
        <>
            <Text as="h2" variant="headline_3" className={headingStyle}>
                Lokale użytkowe w sprzedaży
            </Text>

            <VendorDetailCommercialsList offers={offers.slice(0, 5)} vendorSlug={vendorSlug} />

            {offers.length > 5 && (
                <ShowMoreButton showMoreText="Zobacz więcej" showLessText="Pokaż mniej" className={showMoreButtonStyle}>
                    <VendorDetailCommercialsList offers={offers.slice(5)} vendorSlug={vendorSlug} />
                </ShowMoreButton>
            )}
        </>
    );
};

const commercialsOffersListStyle = css({
    listStyle: "none",
    paddingLeft: 0,
    margin: 0
});

const listItemStyle = css({
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 1.5,
    marginBottom: 1.5
});

const headingStyle = css({
    marginBottom: 4
});

const showMoreButtonStyle = css({
    marginTop: 3
});
import React, {ReactNode} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {ShowMoreButton} from "../../../atoms/ShowMoreButton";
import {OfferDisplayType} from "../../../offer/helpers/OfferDisplayType";
import {OfferType} from "../../../offer/types/OfferType";
import {useAppSelector} from "../../../store/hooks";
import {useGetVendorDetailOffersQuery} from "../../api/get_vendor_detail_offers";
import {convertToVendorDetailViewOffersPayload} from "../../utils/convert_to_vendor_detail_view_offers_payload";
import {VendorDetailCommercialsListItem, VendorDetailCommercialsListItemProps} from "./boxes/VendorDetailCommercialsListBox";

interface IListProps {
    offers: VendorDetailCommercialsListItemProps["offer"][];
    vendorSlug: VendorDetailCommercialsListItemProps["vendorSlug"];
}

interface IProps {
    vendorId: number;
    vendorSlug: string;
}

const VendorDetailCommercialsList: React.FC<IListProps> = ({offers, vendorSlug}) => (
    <ul className={commercialsOffersListStyle}>
        {offers.map((offer) => (
            <li key={offer.id} className={listItemStyle}>
                <VendorDetailCommercialsListItem offer={offer} vendorSlug={vendorSlug} />
            </li>
        ))}
    </ul>
);

export const VendorDetailCommercials = (props: IProps & {children: (sectionContent: ReactNode) => ReactNode}) => {
    const {vendorId, vendorSlug} = props;
    const region = useAppSelector((state) => state.vendorDetailViewSlice.activeOffersListParams.region);

    const {data} = useGetVendorDetailOffersQuery(
        convertToVendorDetailViewOffersPayload({
            vendorId,
            region,
            displayType: OfferDisplayType.FOR_SALE,
            type: [OfferType.COMMERCIAL]
        })
    );
    const offers = data?.results ?? [];

    if (offers.length === 0) {
        return null;
    }

    return props.children(
        <>
            <Text as="h2" variant="headline_3" className={headingStyle}>
                Lokale użytkowe w sprzedaży
            </Text>

            <VendorDetailCommercialsList offers={offers.slice(0, 5)} vendorSlug={vendorSlug} />

            {offers.length > 5 && (
                <ShowMoreButton showMoreText="Zobacz więcej" showLessText="Pokaż mniej" className={showMoreButtonStyle}>
                    <VendorDetailCommercialsList offers={offers.slice(5)} vendorSlug={vendorSlug} />
                </ShowMoreButton>
            )}
        </>
    );
};

const commercialsOffersListStyle = css({
    listStyle: "none",
    paddingLeft: 0,
    margin: 0
});

const listItemStyle = css({
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 1.5,
    marginBottom: 1.5
});

const headingStyle = css({
    marginBottom: 4
});

const showMoreButtonStyle = css({
    marginTop: 3
});
